import request from '@/utils/request'

import { PlanetbTokenPayload } from '@/views/enrollment/types/planetb'

export async function validatePlanetbToken(token: string): Promise<PlanetbTokenPayload> {
  return request({
    url: '/market/planetb/token',
    method: 'post',
    data: { token }
  }) as Promise<PlanetbTokenPayload>
}
